import React from "react";
import "./media.scss";
const Media = ({
  varient,
  imgUrl,
  altText,
  title,
  subtext,
  follower,
  podcasts,
  href,
}) => {
  return (
    <div className={`media ${varient}`}>
      <a href={href} className="media_image">
        <img src={imgUrl} alt={altText} />
      </a>
      <div className="media_info">
        <h3 className="media_title">
          <a href={href}>{title}</a>
        </h3>
        {subtext ? <div className="media_subtext">{subtext}</div> : null}
        {follower ? (
          <div className="media_follower">{follower} Followers</div>
        ) : null}
        {podcasts ? (
          <div className="media_podcasts">{podcasts} Podcasts</div>
        ) : null}
      </div>
    </div>
  );
};
Media.defaultProps = {
  varient: "style1",
  href: "#",
};
export default Media;
